import { Link } from "react-router-dom";
import { UserCircle } from "lucide-react";

const InstagramIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

const FacebookIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const LinkedInIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const XIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground py-8 px-4">
      <div className="max-w-6xl mx-auto text-center space-y-6">
        {/* Bouton Espace Membre mis en avant */}
        <Link 
          to="/espace-membre" 
          className="inline-flex items-center gap-2 bg-primary-foreground text-primary px-6 py-3 rounded-lg font-semibold hover:bg-primary-foreground/90 transition-colors"
        >
          <UserCircle className="w-5 h-5" />
          Accéder à l'Espace Membre
        </Link>

        <div className="flex flex-wrap justify-center gap-6 text-sm">
          <Link 
            to="/" 
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            Accueil
          </Link>
          <Link 
            to="/iadvize" 
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            Action collective iAdvize
          </Link>
          <Link 
            to="/blog" 
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            Blog
          </Link>
          <Link 
            to="/contact" 
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            Contact
          </Link>
          <Link 
            to="/confidentialite" 
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            Politique de Confidentialité
          </Link>
          <Link 
            to="/charte" 
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            Charte du Collectif
          </Link>
          <Link 
            to="/auth" 
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            Connexion
          </Link>
        </div>

        {/* Social icons */}
        <div className="flex justify-center gap-6">
          <a
            href="https://www.instagram.com/collectif.ibbu"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram du Collectif Ibbü"
            className="hover:text-primary-foreground/80 transition-colors"
          >
            <InstagramIcon className="w-5 h-5" />
          </a>
          <a
            href="https://www.facebook.com/collectifibbu"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook du Collectif Ibbü"
            className="hover:text-primary-foreground/80 transition-colors"
          >
            <FacebookIcon className="w-5 h-5" />
          </a>
          <a
            href="https://www.linkedin.com/in/collectif-ibbu/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn du Collectif Ibbü"
            className="hover:text-primary-foreground/80 transition-colors"
          >
            <LinkedInIcon className="w-5 h-5" />
          </a>
          <a
            href="https://x.com/collectifibbu"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X (Twitter) du Collectif Ibbü"
            className="hover:text-primary-foreground/80 transition-colors"
          >
            <XIcon className="w-5 h-5" />
          </a>
        </div>

        <p className="text-sm">
          © {new Date().getFullYear()} Collectif Ibbü - Tous droits réservés
        </p>
      </div>
    </footer>
  );
};

export default Footer;